import { render, staticRenderFns } from "./AddPopupHeader.vue?vue&type=template&id=aca44be0"
import script from "./AddPopupHeader.vue?vue&type=script&lang=js"
export * from "./AddPopupHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports